

/* tslint:disable */




import { ComponentType } from './ComponentType';

export class BaseComponentFilter {
    searchText?: string;
    componentTypes?: ComponentType[];
    taxonomyId?: string | null;

}

